import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import About from "./website/Pages/About";
import BestPregnancyHospitalInPune from "./website/Pages/best-pregnancy-hospital-in-pune";
// import Home from "./website/Pages/Home";
import Contact from "./website/Pages/Contact";
import QuizForm from "./website/Pages/QuizForm";
import Elementalcare from "./website/Pages/Elementalcare";
import Cherishcare from "./website/Pages/Cherishcare";
import EarlyPregnancyPackage from "./website/Pages/PregaStart-Early-Pregnancy-Package";
import PricingPage from "./website/Pages/PricingPage";
import ConfirmPregnancyForm from "./website/Pages/ConfirmPregnancyForm";
import ThankYou from "./website/Pages/ThankYou";
import Pricing from "./website/Pages/Pricing";
import Termsofuse from "./website/Pages/Termsofuse";
import Refundandcancellationpolicy from "./website/Pages/Refundandcancellationpolicy";
import Disclaimerpolicy from "./website/Pages/Disclaimerpolicy";
import PregnancyAI from "./website/Pages/Pregnancy-ai";
import AIDashboardV3 from "./website/AIchat/AIDashboardV3";
import MasterclassLanding from "./website/Pages/Masterclass";
import MasterclassThankYouModal from "./website/Pages/MasterclassThankYouPage";
import Callwithcounselor from "./website/Pages/Callwithcounselor";

// Blogs
import Blogs from "./website/blogs_pages/blogs";
import AntenatalCareContent from "./website/blogs_pages/antenatal-care-what-it-is-and-why-it-matters";
import FirstTrimesterGuide from "./website/blogs_pages/first-trimester-guide-what-to-expect";
import FirstTrimesterSymptoms from "./website/blogs_pages/first-trimester-symptoms-for-moms";
import PregnancyDietPlan from "./website/blogs_pages/pregnancy-diet-plan-guide";
import Pregnancycomplications from "./website/blogs_pages/understanding-most-common-pregnancy-complications";


// Doctorprofile
import Doctorprofile from "./website/Doctorprofile_pages/Doctor-profile";
import DrAaradhyaSharmacontent from "./website/Doctorprofile_pages/Dr-Aaradhya-Sharma";
import DrVikramSinghcontent from "./website/Doctorprofile_pages/Dr-Vikram-Singh";
import DrChayyaPalancontent from "./website/Doctorprofile_pages/Dr-Chayya-Palan​";
import DrAnuradhaTikhecontent from "./website/Doctorprofile_pages/Dr-Anuradha-Tikhe-Dietitian";
import DrDeepakBhuktarcontent from "./website/Doctorprofile_pages/Dr-Deepak-Bhuktar";
import DrGayatriNavaleContent from "./website/Doctorprofile_pages/Dr-Gayatri-Navale​";
import DrNishaKapoorContent from "./website/Doctorprofile_pages/Dr-Nisha-Kapoor​";
import DrAnuradhaTikheYogaContent from "./website/Doctorprofile_pages/Dr-Anuradha-Tikhe-Yoga";
import DrAnandNarnawareContent from "./website/Doctorprofile_pages/Dr-Anand-Narnaware";
import CrystalClearImagingContent from "./website/Doctorprofile_pages/Crystal-Clear-Imaging-Content";

// import MeetingNew from "./website/Pages/MeetingNew";
//patient
import Dashboard from "./patient/Pages/Dashboard";
// import Login from "./Pages/login";
import DoctorConsultation from "./patient/Pages/Doctor_consultation";
import Pathology from "./patient/Pages/Pathology";
// import HealthTracker from "./patient/Pages/HealthTracker";
import Reports from "./patient/Pages/Reports";
import GarbhaSanskar from "./patient/Pages/GarbhaSanskar";
import Sonography from "./patient/Pages/Sonography";
import PregnancyCare from "./patient/Pages/PregnancyCare";
import ContactPatient from "./patient/Pages/Contact";
// import SplashScreen from "./patient/Components/SplashScreen";
import Loginform from "./patient/Pages/Loginform";
import Signup from "./patient/Pages/Signup";
import Casepaper from "./patient/Pages/Casepaper";
import Profile from "./patient/Pages/Profile";
import DoctorDashboard from "./doctor/Pages/Dashboard";
// import DoctorSplashScreen from "./doctor/Pages/SplashScreen";
import Communication from "./doctor/Pages/Communication";
import Patient from "./doctor/Pages/Patient";
import PregaStart from "./doctor/Pages/PregaStart";
import DoctorProfile from "./doctor/Pages/Profile";
import Payment from "./doctor/Pages/Payment";
import Login from "./doctor/Pages/Login";
import SignupDoctor from "./doctor/Pages/Signup";
// import MeetingNewPatient from "./doctor/Pages/MeetingNew";
import YogaPatient from "./doctor/Pages/YogaPatient";
import ProtectedRoute from "./website/components/ProtectedRoute";
import ChangePassword from "./patient/Pages/ChangePassword";
import DailyActivity from "./patient/Pages/DailyActivity";
import Forgetpassword from "./common/forgetpassword/Forgetpassword";
import Newhome from "./website/Pages/Newhome";

function AppRoutes() {
  return (
    <div>
      <Router>
        <div>
          <Routes>
            {/* <Route path="/new-home" element={<Home />} /> */}
            <Route path="/" element={<Newhome />} />
            <Route path="/about" element={<About />} />
            <Route
              path="/best-pregnancy-hospital-in-pune"
              element={<BestPregnancyHospitalInPune />}
            />
            <Route path="/contact" element={<Contact />} />
            <Route path="/form" element={<QuizForm />} />
            <Route path="/Pregnancy-ai" element={<PregnancyAI />} />
            <Route path="/AIDashboardV3" element={<AIDashboardV3 />} />
            <Route path="/Masterclass" element={<MasterclassLanding />} />
            <Route path="/MasterclassThankYouPage" element={<MasterclassThankYouModal />} />
            <Route path="/Callwithcounselor" element={<Callwithcounselor />} />

            <Route path="/blogs" element={<Blogs />} />
            <Route
              path="/antenatal-care-what-it-is-and-why-it-matters"
              element={<AntenatalCareContent />}
            />
            <Route
              path="/first-trimester-guide-what-to-expect"
              element={<FirstTrimesterGuide />}
            />
            <Route
              path="/first-trimester-symptoms-for-moms"
              element={<FirstTrimesterSymptoms />}
            />
            <Route
              path="/pregnancy-diet-plan-guide"
              element={<PregnancyDietPlan />}
            />
            <Route
              path="/understanding-most-common-pregnancy-complications"
              element={<Pregnancycomplications />}
            />

            
            <Route path="/elemental-care" element={<Elementalcare />} />
            <Route path="/cherish-care" element={<Cherishcare />} />
            <Route
              path="/PregaStart-Early-Pregnancy-Package"
              element={<EarlyPregnancyPackage />}
            />
            <Route
              path="/PricingPage"
              element={<PricingPage />}
            />
            <Route
              path="/Doctor-profile"
              element={<Doctorprofile />}
            />
            <Route
              path="/Dr-Aaradhya-Sharma"
              element={<DrAaradhyaSharmacontent />}
            />
            <Route
              path="/Dr-Vikram-Singh"
              element={<DrVikramSinghcontent />}
            />
            <Route
              path="/Dr-Chayya-Palan"
              element={<DrChayyaPalancontent />}
            />
            <Route
              path="/Dr-Anuradha-Tikhe-Dietitian"
              element={<DrAnuradhaTikhecontent />}
            />
            <Route
              path="/Dr-Deepak-Bhuktar"
              element={<DrDeepakBhuktarcontent />}
            />
            <Route
              path="/Dr-Gayatri-Navale​"
              element={<DrGayatriNavaleContent />}
            />
            <Route
              path="/Dr-Nisha-Kapoor​"
              element={<DrNishaKapoorContent />}
            />
            <Route
              path="/Dr-Anuradha-Tikhe-Yoga"
              element={<DrAnuradhaTikheYogaContent />}
            />
            <Route
              path="/Dr-Anand-Narnaware"
              element={<DrAnandNarnawareContent />}
            />
            <Route
              path="/Crystal-Clear-Imaging-Content"
              element={<CrystalClearImagingContent />}
            />
            <Route
              path="/Confirm-Pregnancy-Form"
              element={<ConfirmPregnancyForm />}
            />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/terms-of-use" element={<Termsofuse />} />
            <Route
              path="/refund-&-cancellation-policy"
              element={<Refundandcancellationpolicy />}
            />
            <Route path="/disclaimer-policy" element={<Disclaimerpolicy />} />
            {/* <Route path="/meeting" element={<MeetingNew />} /> */}

            {/* patient Router */}
            {/* <Route exact path="/">
              <SplashScreen />
            </Route> */}
            <Route exact path="/patient/Signup" element={<Signup />} />

            <Route exact path="/patient/Casepaper" element={<Casepaper />} />

            <Route exact path="/patient/loginform" element={<Loginform />} />
            <Route exact path="/patient/Dashboard" element={<Dashboard />} />
            <Route
              path="/patient/Doctor_consultation"
              element={
                <ProtectedRoute
                  element={DoctorConsultation}
                  requiredStatus={true} // Only allow if the user is a paid user
                  redirectTo="/patient/Garbha_Sanskar"
                />
              }
            />
            <Route
              path="/patient/Reports"
              element={
                <ProtectedRoute
                  element={Reports}
                  requiredStatus={true} // Only allow if the user is a paid user
                  redirectTo="/patient/Garbha_Sanskar"
                />
              }
            />
            <Route
              path="/patient/Pathology"
              element={
                <ProtectedRoute
                  element={Pathology}
                  requiredStatus={true} // Only allow if the user is a paid user
                  redirectTo="/patient/Garbha_Sanskar"
                />
              }
            />
            <Route
              path="/patient/Sonography"
              element={
                <ProtectedRoute
                  element={Sonography}
                  requiredStatus={true} // Only allow if the user is a paid user
                  redirectTo="/patient/Garbha_Sanskar"
                />
              }
            />

            <Route
              path="/patient/PregnancyCare"
              element={
                <ProtectedRoute
                  element={PregnancyCare}
                  requiredStatus={true} // Only allow if the user is a paid user
                  redirectTo="/patient/Garbha_Sanskar"
                />
              }
            />
            {/* <Route path="/patient/Pathology" element={<Pathology />}  /> */}
            {/* <Route
              exact
              path="/patient/Health_Tracker"
              element={<HealthTracker />}
            /> */}

            <Route
              exact
              path="/patient/Garbha_Sanskar"
              element={<GarbhaSanskar />}
            />

            {/* <Route exact path="/patient/Sonography" element={ <Sonography />}  /> */}
            {/* <Route exact path="/patient/PregnancyCare" element={<PregnancyCare />}  /> */}
            <Route exact path="/patient/Contact" element={<ContactPatient />} />
            <Route exact path="/patient/profile" element={<Profile />} />
            {/* <Route exact path="/patient/meeting" element={<MeetingPatient />}  /> */}
            <Route
              exact
              path="/patient/daily-activiy"
              element={<DailyActivity />}
            />
            {/* Doctor router */}
            {/* <Route exact path="/" element={<SplashScreen />} /> */}

            <Route exact path="/doctor/Signup" element={<SignupDoctor />} />
            <Route exact path="/doctor/login" element={<Login />} />
            <Route
              exact
              path="/doctor/Dashboard"
              element={<DoctorDashboard />}
            />
            <Route
              exact
              path="/doctor/Communication"
              element={<Communication />}
            />
            <Route exact path="/doctor/Patient" element={<Patient />} />
            <Route exact path="/doctor/PregaStart" element={<PregaStart />} />
            <Route exact path="/doctor/Payment" element={<Payment />} />
            <Route exact path="/doctor/Profile" element={<DoctorProfile />} />
            <Route
              exact
              path="/doctor/change-password"
              element={<ChangePassword />}
            />
            {/* <Route exact path="/doctor/meeting" element={<MeetingNew />} /> */}
            <Route exact path="/doctor/yogapatient" element={<YogaPatient />} />
            <Route exact path="/forget-password" element={<Forgetpassword />} />
          </Routes>
        </div>
      </Router>
    </div>
  );
}

export default AppRoutes;
